export default "__VITE_ASSET__qNLcjmj9__"